

































import Vue from 'vue'
import ChildCategories from '@/search/components/category/ChildCategories.vue'
import BaseImage from '@/common/components/BaseImage.vue'
import { getBrandCategories } from '@/search/services'
import { BrandCategory, BrandValue } from '@/search/types'
import { DisplayChildCategory } from '@/common/types'
import { SVG_PLACEHOLDER_IMAGES, IMAGE_VARIANT_NAMES} from '@/common/constants'
export default Vue.extend({
  components: {
    ChildCategories,
    BaseImage
  },
  props: {
    brandId: {
      type: Number,
      required: true
    },
    brands: {
      type: Array as () => BrandValue[],
      required: true
    },
    itemTotalCount: {
      type: Number,
      required: true
    }
  },
  data(): {
    brandCategories: BrandCategory[]
  } {
    return {
      brandCategories: []
    }
  },
  computed: {
    brand(): BrandValue | undefined {
      return this.brands.find(brand => brand.id === this.brandId)
    },
    displayedBrandCategories(): DisplayChildCategory[] {
      return this.brandCategories.reduce(
        (acc, curr) =>
          acc.concat(
            ...curr.brandChildCategoriesWithProducts.map(item => ({
              id: item.id,
              displayName: item.displayName,
              thumbnail: item.iconImage,
              alt: item.iconImageAlt || item.displayName,
              url: item.url
            }))
          ),
        [] as DisplayChildCategory[]
      )
    },
    placeholder(): string {
        return SVG_PLACEHOLDER_IMAGES.BRAND_LOGO
    },
    IMAGE_VARIANT_NAMES() {
        return IMAGE_VARIANT_NAMES
    }
  },
  async created() {
    const brandCategoriesData = await getBrandCategories(this.brandId)
      if (brandCategoriesData) {
        this.brandCategories = brandCategoriesData as BrandCategory[]
      }
  }
})
